import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ highlightActions, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (highlightActions.loading) {
      return "is Loading";
    }
    if (isEmpty(highlightActions.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Action</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {highlightActions.data.map((highlightAction) => (
            <tr key={highlightAction.id}>
              <td>
                <a>{highlightAction.id}</a>
              </td>
              <td>
                <a>{highlightAction.name}</a>
              </td>
              <td>{highlightAction.action.join(',')}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/highlight-actions/${highlightAction.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(highlightAction.id)}
                    to={`/highlight-actions/${highlightAction.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/HighlightAction/Index/Table.js